<template>
  <div class="app-container">
    <el-card>
      <div class="filter-container">
        <el-input v-model="query.room_name" placeholder="考场名称" style="width:200px;" class="filter-item" @keyup.enter.native="getList" />
        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" @click="handleCreate">新增</el-button>
        <!-- <el-button type="danger" icon="el-icon-delete" :disabled="!multipleSelection.length" @click="handleBatchDelete">批量删除</el-button> -->
        <!-- <el-button icon="el-icon-download" @click="handleExport">导出</el-button> -->
      </div>
      <el-table :data="list" border v-loading="loading" style="margin-top:20px;" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column prop="id" label="ID" width="60" align="center" >
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="room_name" label="考场名称" />
        <el-table-column prop="room_location" label="考场地点" />
        <el-table-column prop="room_capacity" label="座位数" width="80" align="center" />
        <el-table-column prop="room_description" label="描述" />
        <el-table-column label="状态" width="180" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用"
              @change="val => handleToggleStatus(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="160" />
        <el-table-column prop="updatetime" label="更新时间" width="160" />
        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="{row}">
            <el-button type="primary" size="mini" @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
            <el-button type="success" size="mini" @click="handleCopy(row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50]"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { getExamRoomList, deleteExamRoom, batchDeleteExamRoom, updateExamRoomStatus, exportExamRoom, copyExamRoom } from '@/api/exam'
export default {
  name: 'ExamRoomsList',
  data() {
    return {
      query: {
        page: 1,
        limit: 20,
        room_name: ''
      },
      list: [],
      total: 0,
      loading: false,
      multipleSelection: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await getExamRoomList(this.query)
        this.list = res.data.list
        this.total = res.data.total
      } catch (e) {
        this.list = []
        this.total = 0
      }
      this.loading = false
    },
    handleCreate() {
      this.$router.push({ path: '/exam/rooms/edit' })
    },
    handleEdit(row) {
      this.$router.push({ path: `/exam/rooms/edit/${row.id}` })
    },
    handleDelete(row) {
      this.$confirm('确定删除该考场吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteExamRoom(row.id)
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleBatchDelete() {
      this.$confirm('确定批量删除选中的考场吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ids = this.multipleSelection.map(item => item.id)
        await batchDeleteExamRoom(ids)
        this.$message.success('批量删除成功')
        this.getList()
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async handleToggleStatus(row, val) {
      try {
        await updateExamRoomStatus(row.id, { status: val })
        this.$message.success('状态已更新')
        this.getList()
      } catch (e) {
        this.$message.error('状态更新失败')
        row.status = val === 1 ? 0 : 1
      }
    },
    handleSizeChange(val) {
      this.query.limit = val
      this.getList()
    },
    handleReset() {
      this.query.room_name = ''
      this.query.page = 1
      this.getList()
    },
    async handleExport() {
      try {
        const res = await exportExamRoom(this.query)
        const isCSV = res.type.includes('csv')
        if (!isCSV) {
          const text = await res.text()
          let msg = '导出失败'
          try { msg = JSON.parse(text).msg || msg } catch (e) { msg = text }
          this.$message.error(msg)
          return
        }
        const url = window.URL.createObjectURL(res)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '考场列表.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    async handleCopy(row) {
      this.$confirm('确定要复制该考场吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.copyExamRoom(row.id)
          this.$message.success('复制成功')
          this.getList()
        } catch (e) {
          this.$message.error('复制失败')
        }
      })
    },
    copyExamRoom(id) {
      return copyExamRoom(id)
    }
  }
}
</script>
<style scoped>
.filter-container { margin-bottom: 20px; }
.pagination-container { margin-top: 20px; text-align: right; }
</style> 


// WEBPACK FOOTER //
// src/views/exam/ExamRoomsList.vue